window.Reverb = window.Reverb || {};
Reverb.DashboardSelling = Reverb.DashboardSelling || {};

Reverb.DashboardSelling.SellerSales = (function () {
  function init() {
    extendInputDefinition();
    addInputMasks();
  }

  function extendInputDefinition() {
    $.extend($.inputmask.defaults.definitions, {
      A: {
        validator: '[A-Za-z0-9]',
        cardinality: 1,
        casing: 'upper',
      },
    });
  }

  function addDiscountCodeInputMask(elements) {
    elements.inputmask('A{20}', {
      placeholder: '',
    });
  }

  function addDiscountPercentInputMask(elements) {
    elements.inputmask('9{2}', {
      placeholder: '',
    });
  }

  function addInputMasks() {
    addDiscountCodeInputMask($('[data-sale-discount-code-input]'));
    addDiscountPercentInputMask($('[data-sale-discount-percent-input]'));
  }

  return {
    init,
  };
}());

$(Reverb.DashboardSelling.SellerSales.init);
